




































import { DashboardVendedorUltimaVenda } from "@/services/dashboard-vendedor.service";
import dayjs from "dayjs";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class WidgetUltimasVendasVendedor extends Vue {
  @Prop({ required: true })
  readonly ultimasVendas!: DashboardVendedorUltimaVenda[];

  formatVendaData(value: string): string {
    return dayjs(value).format("DD/MM/YYYY HH:mm");
  }
}
